import React from 'react';

export function CaisseModuleIcon({ className = '' }) {
  return (
    <svg
      className={`dashboard-home-card__module-icon dashboard-home-card__module-icon--caisse ${className}`.trim()}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="10"
        y="6"
        width="28"
        height="36"
        rx="4"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="2.2"
      />
      <rect x="14" y="10" width="20" height="8" rx="1.5" fill="currentColor" fillOpacity="0.25" />
      <circle cx="17" cy="24" r="2.2" fill="currentColor" />
      <circle cx="24" cy="24" r="2.2" fill="currentColor" />
      <circle cx="31" cy="24" r="2.2" fill="currentColor" />
      <circle cx="17" cy="31" r="2.2" fill="currentColor" />
      <circle cx="24" cy="31" r="2.2" fill="currentColor" />
      <circle cx="31" cy="31" r="2.2" fill="currentColor" />
      <rect x="14" y="36" width="10" height="3" rx="1" fill="currentColor" />
      <rect x="28" y="36" width="6" height="3" rx="1" fill="currentColor" fillOpacity="0.5" />
    </svg>
  );
}

export function FacturationModuleIcon({ className = '' }) {
  return (
    <svg
      className={`dashboard-home-card__module-icon dashboard-home-card__module-icon--nh ${className}`.trim()}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 6h16l8 8v28a3 3 0 0 1-3 3H12a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3z"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path d="M28 6v8h8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 24h18M15 30h14M15 36h10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="35" cy="33" r="10" fill="#0d9488" fillOpacity="0.2" stroke="currentColor" strokeWidth="2.2" />
      <path
        d="M35 28.5v9M32 31.5h6"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DeclarationModuleIcon({ className = '' }) {
  return (
    <svg
      className={`dashboard-home-card__module-icon dashboard-home-card__module-icon--declarations ${className}`.trim()}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="24"
        cy="24"
        r="16"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="2.2"
      />
      <path
        d="M24 14v11l7 4"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PaieModuleIcon({ className = '' }) {
  return (
    <svg
      className={`dashboard-home-card__module-icon dashboard-home-card__module-icon--paie ${className}`.trim()}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="24"
        cy="16"
        r="7"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="2.2"
      />
      <path
        d="M10 38c0-7.2 6.3-12 14-12s14 4.8 14 12"
        fill="currentColor"
        fillOpacity="0.14"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
